import React, { PropTypes } from 'react';
import './styles.scss';

import PlansSection from '../../components/PlansSection'
import SiteHeader from '../../components/SiteHeader'

class PricingPage extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {};
  }

  render () {
    return (
      <div className="PricingPage">
        <SiteHeader />

        <div className="hero">
          {/* Only using this to somewhat fix the green background */}
        </div>

        <PlansSection />

      </div>
    );
  }
}

PricingPage.propTypes = {

};

PricingPage.defaultProps = {

};

export default PricingPage;



/** WEBPACK FOOTER **
 ** ./pricing/index.js
 **/